module.exports = __webpack_public_path__ + "static/img/BG.b1d00658.jpg";